import { transport } from 'config/transport';

export function callApiDeleteNun(congDoanId, nunId) {
    return transport.del(`/congdoan/${congDoanId}/nun/${nunId}`);
}
